import { render, staticRenderFns } from "./ConfigurationForm116.vue?vue&type=template&id=12c51745&scoped=true&lang=pug&"
import script from "./ConfigurationForm116.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationForm116.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationForm116.vue?vue&type=style&index=0&id=12c51745&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c51745",
  null
  
)

export default component.exports